import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';

import CredentialCardAlert from 'components/resources/CredentialCardAlert';

import {CREDENTIALS_KEYS} from 'components/security/utils/consts';

import {setDefaultCredentials} from 'modules/credentials';


/** Component for a ResourceLogs Container */
export class AlertCardPendingCredentialContainer extends Component {

    static propTypes = {
        accounts: PropTypes.object, // All necesary data to show in the component
        type:     PropTypes.string // (success || warning) depending if is going to show the accounts with or without credentials
    };

    componentWillMount() {
        this.handleOnClickAccount = this.handleOnClickAccount.bind(this);
    }


    handleOnClickAccount(account) {
        const {dispatch} = this.props;

        dispatch(setDefaultCredentials(account, CREDENTIALS_KEYS.KEY_SERVICE_DISCOVERY));
        dispatch(routerActions.push(`/my/credentials/new`));
    }

    render() {
        const {type, intl:{formatMessage}, accounts} = this.props;

        const message = type === 'success' ? formatMessage({id: 'discoverSuccess'}) : formatMessage({id: 'discoverWarning'});

        return (
            <div>
                {message}
                <br/>
                <CredentialCardAlert accounts={accounts} type={type} onClick={this.handleOnClickAccount}/>
            </div>);
    }
}

const mapStateToProps = state => state;

export default connect(mapStateToProps)(injectIntl(AlertCardPendingCredentialContainer));



// WEBPACK FOOTER //
// ./src/containers/resources/AlertCardPendingCredentialContainer.jsx